import { NotFoundError } from "@sportactics/errors";

export class PreferencesNotFoundError extends NotFoundError {
  constructor() {
    super("Preferences", "preferences");
  }
}
